import { InternalAxiosRequestConfig } from 'axios';

// The request token returned by GET /auth/antiforgery-token.
// This is NOT the cookie value — ASP.NET Core uses a two-token system:
//   - Cookie token  → stored in the XSRF-TOKEN cookie by the server
//   - Request token → returned in the response body by GetAndStoreTokens()
//   - The header must contain the REQUEST token, otherwise the server rejects with
//     "cookie token and request token were swapped"
let csrfRequestToken: string | null = null;

/** Callback used by the app to store the request token from the antiforgery endpoint. */
export const setCsrfRequestToken = (token: string | null) => {
  csrfRequestToken = token;
};

export const csrfInterceptor = (config: InternalAxiosRequestConfig) => {
  // Only attach CSRF token to mutating requests
  if (config.method && ['post', 'put', 'delete', 'patch'].includes(config.method)) {
    if (csrfRequestToken && config.headers) {
      config.headers['X-XSRF-TOKEN'] = csrfRequestToken;
    }
  }
  return config;
};
